import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import Reveal from "./Reveal";

const FRIED_IMG =
  "https://customer-assets-lqy194kg.emergentagent.net/job_artichoke-cafe-green/artifacts/anm99pk5_image0%20%2811%29.jpeg";

const TIERS = [
  { pc: 10, price: "$9.75", note: "The solo crush" },
  { pc: 20, price: "$14.50", note: "Made for sharing" },
  { pc: 30, price: "$19.99", note: "The family pack" },
];

export default function Signature() {
  return (
    <section id="famous" data-testid="signature-section" className="bg-cream py-24 lg:py-32">
      <div className="mx-auto grid max-w-6xl items-center gap-16 px-5 lg:grid-cols-2">
        <div>
          <Reveal>
            <p className="font-editorial text-sm font-semibold italic tracking-[0.3em] text-grape">
              01 — THE FAMOUS ONE
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 font-display text-4xl font-bold leading-[1.02] text-chalk sm:text-5xl lg:text-6xl">
              Fried artichoke hearts, <span className="text-artichoke">golden</span> &{" "}
              <span className="font-editorial font-semibold italic text-crispy">gone fast.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-5 max-w-md text-base leading-relaxed text-chalk/65">
              Fresh Castroville artichokes, battered to order and fried
              shatter-crisp. Served hot with our house dipping sauce — the
              basket people drive across the county for.
            </p>
          </Reveal>

          <div className="mt-9 grid grid-cols-3 gap-3 sm:gap-4">
            {TIERS.map((t, i) => (
              <Reveal key={t.pc} delay={0.1 + i * 0.08}>
                <motion.div
                  whileHover={{ y: -6, rotate: i === 1 ? 0 : i === 0 ? -1.5 : 1.5 }}
                  data-testid={`fried-tier-${t.pc}`}
                  className={`rounded-3xl border-2 p-4 text-center sm:p-5 ${
                    i === 1
                      ? "border-artichoke bg-artichoke text-cream shadow-xl shadow-artichoke/25"
                      : "border-leafline bg-sage text-chalk"
                  }`}
                >
                  <div className="font-display text-3xl font-bold sm:text-4xl">
                    {t.pc}
                    <span className="text-sm font-semibold"> pc</span>
                  </div>
                  <div
                    className={`mt-1 font-editorial text-lg font-semibold ${
                      i === 1 ? "text-gold" : "text-crispy"
                    }`}
                  >
                    {t.price}
                  </div>
                  <div
                    className={`mt-1 text-[10px] font-bold uppercase tracking-wider sm:text-[11px] ${
                      i === 1 ? "text-cream/70" : "text-chalk/50"
                    }`}
                  >
                    {t.note}
                  </div>
                </motion.div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.3}>
            <a
              data-testid="signature-order-button"
              href="tel:8316334259"
              className="mt-9 inline-flex items-center gap-3 rounded-full bg-grape px-7 py-3.5 font-display text-base font-semibold text-cream shadow-lg shadow-grape/25 transition-all hover:-translate-y-0.5 hover:brightness-110"
            >
              <Phone className="h-4 w-4" />
              Call in a batch · (831) 633-4259
            </a>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="relative">
          <div
            aria-hidden
            className="absolute inset-0 scale-90 rounded-full bg-[radial-gradient(circle_at_center,rgba(224,168,56,0.35),transparent_65%)] blur-2xl"
          />
          <div className="relative rotate-2 overflow-hidden rounded-[2.5rem] border-8 border-sage shadow-2xl shadow-artichoke/20">
            <img
              src={FRIED_IMG}
              alt="Stacked toasted sandwich at Giant Artichoke Cafe"
              className="h-[420px] w-full object-cover sm:h-[540px]"
              data-testid="signature-photo"
            />
          </div>
          <div
            data-testid="signature-dip-note"
            className="absolute -bottom-5 left-6 -rotate-3 rounded-2xl bg-chalk px-5 py-3 font-editorial text-sm italic text-gold shadow-xl"
          >
            served hot w/ house dip ★
          </div>
        </Reveal>
      </div>
    </section>
  );
}
